<!--
 * @Description: 入参/出参table
 * @Date: 2022-03-02 13:55:53
 * @LastEditTime: 2023-05-04 15:25:19
-->
<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="dataSource"
      :row-key="(record) => record.identifier"
      :pagination="pagination"
    >
      <template #bodyCell="payload">
        <template v-if="payload.column.key === 'dataType'">
          <svg-icon
            style="margin-right: 8px; font-size: 16px; cursor: pointer"
            icon-class="book"
            @click="seeExpand(payload.record)"
          />
          <span>{{ payload.text }}</span>
        </template>
      </template>
    </a-table>
    <Drawer
      title="扩展信息"
      placement="right"
      v-model:visible="showExpandDrawer"
      :width="500"
      :footer="false"
    >
      <ExpandTable :record="selectRecord" />
    </Drawer>
  </div>
</template>
<script>
import { defineComponent, reactive, ref } from "vue";
import ExpandTable from "./expand-table/index.vue";
import Drawer from "@/components/model/drawer";
// import { message } from "ant-design-vue";

export default defineComponent({
  components: {
    ExpandTable,
    Drawer
  },
  props: {
    record: Object,
    type: String // 判断入参还是出参
  },
  setup(props) {
    const selectRecord = ref({});
    const columns = [
      {
        title: props.type + "编码",
        dataIndex: "identifier",
        key: "identifier",
        ellipsis: true
      },
      {
        title: props.type + "名称",
        dataIndex: "name",
        key: "name",
        ellipsis: true
      },
      {
        title: "描述",
        dataIndex: "description",
        key: "description",
        ellipsis: true
      },
      {
        title: "数据类型",
        dataIndex: "dataType",
        key: "dataType",
        ellipsis: true
      }
    ];
    const dataSource = props.type == "入参" ? props.record.inputs : props.record.outputs;
    console.log(dataSource, "????????????????????");
    const pagination = reactive({
      showTotal: (total) => `共 ${total} 项数据`,
      pageNum: 1,
      pageSize: 5,
      total: dataSource.length
    });
    const showExpandDrawer = ref(false);
    const seeExpand = (record) => {
      // console.log(record);
      // if (record.specifications || record.specification) {
      selectRecord.value = record;
      showExpandDrawer.value = true;
      // } else {
      //   message.warn("缺少拓展信息");
      //   return;
      // }
    };
    // 判断是否有扩展信息
    const haveExpand = (record) => {
      if (record.specifications && record.specifications.length) {
        return true;
      }
      if (record.specification && JSON.stringify(record.specification) !== "{}") {
        return true;
      }
      return false;
    };
    return {
      columns,
      dataSource,
      pagination,
      seeExpand,
      showExpandDrawer,
      selectRecord,
      haveExpand
    };
  }
});
</script>
